"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _color = _interopRequireDefault(require("color"));
var _Content = _interopRequireDefault(require("../Content"));
var _style = _interopRequireDefault(require("./style.css"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
var Vertical = /*#__PURE__*/function (_React$Component) {
  _inherits(Vertical, _React$Component);
  var _super = _createSuper(Vertical);
  function Vertical() {
    var _this;
    _classCallCheck(this, Vertical);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty(_assertThisInitialized(_this), "state", {
      currentTab: _this.props.tabs[0].id
    });
    _defineProperty(_assertThisInitialized(_this), "setActiveTab", function (e, tabId) {
      e && e.preventDefault();
      _this.setState({
        currentTab: tabId
      });
    });
    return _this;
  }
  _createClass(Vertical, [{
    key: "render",
    value: function render() {
      var _this2 = this;
      var tabs = this.props.tabs;
      var displayOptions = this.props.displayOptions;
      var tabContent;
      for (var i = 0; i < tabs.length; i++) {
        if (tabs[i].id === this.state.currentTab) {
          var tab = tabs[i];
          tabContent = /*#__PURE__*/_react["default"].createElement(_Content["default"], {
            config: tab.config,
            displayOptions: displayOptions,
            image: tab.image,
            layout: tab.layout,
            text: tab.text,
            video: tab.video,
            key: i
          });
        }
      }
      var bgColor = (0, _color["default"])(displayOptions.portal.tabActiveColor).lighten(0.15);
      return /*#__PURE__*/_react["default"].createElement("div", {
        className: _style["default"].infoBar,
        style: displayOptions && displayOptions.portal ? {
          borderTopColor: displayOptions.portal.infoBarAccentColor
        } : {}
      }, tabs.length > 1 ? /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("ul", {
        className: "nav nav-pills nav-stacked"
      }, tabs.map(function (tab) {
        return /*#__PURE__*/_react["default"].createElement("li", {
          key: tab.id,
          role: "presentation"
        }, /*#__PURE__*/_react["default"].createElement("a", {
          className: _style["default"].navPill,
          onClick: function onClick(e) {
            return _this2.setActiveTab(e, tab.id);
          },
          href: "#",
          style: _this2.state.currentTab === tab.id ? {
            backgroundColor: bgColor,
            color: '#fff'
          } : {
            backgroundColor: displayOptions.portal.tabActiveColor,
            color: '#fff'
          }
        }, tab.name));
      }))), /*#__PURE__*/_react["default"].createElement("div", null, tabContent)) : tabContent);
    }
  }]);
  return Vertical;
}(_react["default"].Component);
exports["default"] = Vertical;
_defineProperty(Vertical, "propTypes", {
  tabs: _propTypes["default"].array,
  displayOptions: _propTypes["default"].object
});